import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PosForm from "../components/PostForm";
import Ticket from "../components/Ticket";

export default function Pos() {
  const [saleResult, setSaleResult] = useState(null);
  const navigate = useNavigate();

  const handleAfterPrint = () => {
    setSaleResult(null);

    // Coming from a split bill? Return to the order
    const pending = localStorage.getItem("pending_split_bill");
    if (pending) {
      try {
        const { return_to_orden, items_facturados, total_items_orden } = JSON.parse(pending);
        localStorage.removeItem("pending_split_bill");

        const allInvoiced = items_facturados.length >= total_items_orden;

        if (allInvoiced) {
          // All items invoiced, go to tables
          navigate("/mesas");
        } else {
          // Items remaining, return to the order with state
          navigate(`/ordenes/${return_to_orden}`, {
            state: {
              items_ya_facturados: items_facturados,
              abrir_separada: true,
            },
          });
        }
      } catch {
        localStorage.removeItem("pending_split_bill");
      }
    }
  };

  return (
    <>
      <div className="container">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Point of Sale</h2>
          </div>
          <div className="card-body">
            <PosForm onSuccess={(data) => setSaleResult(data)} />
          </div>
        </div>
      </div>

      {saleResult && <Ticket invoice={saleResult} onAfterPrint={handleAfterPrint} />}
    </>
  );
}